export const invalidarUsuario = (user, naoPermitidos) => {
  const { perfil } = user;
  return naoPermitidos.includes(perfil);
};
